import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { push } from 'connected-react-router';
import { Dispatch } from 'redux';

import { updateQueryString } from '../../../providers/location.provider';
import { MainStore } from '../../store';
import {
    SET_ERRORS,
    SET_NOTICES,
    setError,
    setErrors,
    setNotice,
    setNotices,
    TARGET_ID_MODAL,
    TOGGLE_POPUP,
    togglePopup,
} from '../../ui';

export const popupUiHandler = (store: MainStore, next: Dispatch, action: ReturnType<typeof togglePopup>): void => {
    const isIOS = /iP(ad|hone|od)/.test(navigator.userAgent);
    const { status, name } = action.payload;
    const targetElement = document.getElementById(TARGET_ID_MODAL) as HTMLElement;
    const {
        router: {
            location: { search },
        },
    } = store.getState();

    const openingCollection = (name: string, val: 1 | 0) => {
        if (name === 'collection') {
            store.dispatch(push({ search: updateQueryString(search, { share: val }) }));
        }
    };

    if (status) {
        openingCollection(name, 1);

        if (!isIOS) {
            disableBodyScroll(targetElement);
        } else {
            Object.assign(document.body.style, { WebkitOverflowScrolling: 'none', overflow: 'hidden' });
        }
    } else {
        openingCollection(name, 0);

        if (!isIOS) {
            enableBodyScroll(targetElement);
        } else {
            Object.assign(document.body.style, { WebkitOverflowScrolling: 'auto', overflow: 'auto' });
        }
    }

    next(action);
};

export const errorsHandler = (store: MainStore, next: Dispatch, action: ReturnType<typeof setErrors>): void => {
    action.payload.map(({ code, message }) => store.dispatch(setError({ [code]: { code, message } })));

    next(action);
};

export const noticesHandler = (store: MainStore, next: Dispatch, action: ReturnType<typeof setNotices>): void => {
    action.payload.map(({ code, message }) => store.dispatch(setNotice({ [code]: { code, message } })));

    next(action);
};

const uiInjectHandlers = {
    [TOGGLE_POPUP]: popupUiHandler,
    [SET_ERRORS]: errorsHandler,
    [SET_NOTICES]: noticesHandler,
};

export default uiInjectHandlers;
